import Div from "@jumbo/shared/Div/Div";
import React, { useCallback, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import {
  Autocomplete,
  Box,
  Button,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Heading from "app/pages/Component/Heading";
import { State, City } from "country-state-city";
import SalesTable from "../SalesTable";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { Axios } from "index";
import AllApis from "app/Apis/apis";
import { getAllSalesOrders } from "app/redux/actions/ConfirmSalesOrders";
import Loader from "app/pages/Component/Loader";

export default function ListSalesOrders() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState("desc");
  const [sortBy, setSortBy] = useState("created_at");
  const [isLogModalOpen, setLogModalOpen] = useState(false);
  const [value, setValue] = React.useState(0);
  const [type, settype] = useState("retailers");
  const { area, district, location, taluka } = useSelector(
    (state) => state?.addressDropdown
  );
  const { loading } = useSelector((state) => state?.salesOrderReducer);

  const [emptyVal, setEmptyVal] = useState();
  const [dropdownList, setDropdownList] = useState({
    stateList: State.getStatesOfCountry("IN"),
    cityList: City.getCitiesOfState("IN", "MH"),
    orderNoList: [],
  });
  const [filters, setFilters] = useState({
    order_status: "",
    from: "",
    to: "",
  });

  const todaysDate = new Date(Date.now()).toISOString().split("T")[0];
  const TabChange = () => {
    setFilters({
      from: "",
      to: "",
    });
    setEmptyVal(!emptyVal);
    setPage(1);
  };

  const datepickerStyling = {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#aeb7bd ", // or any other color you prefer
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#475259", // Change to the color you want on hover
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#7352C7", // Change to the color you want when focused
    },
    "& .MuiOutlinedInput-root.Mui-focused:hover .MuiOutlinedInput-notchedOutline":
      {
        borderColor: "#7352C7", // Keep the same color as focused when hovered
      },
    "& .MuiInputLabel-outlined": {
      color: "#98a3aa", // Default label color
      "&.Mui-focused": {
        color: "#7352C7", // Label color on focus
      },
    },
  };

  const filterFun = () => {
    const filter = {};
    for (let i in filters) {
      if (filters[i] != "" && i != "from" && i != "to") {
        filter[`current_data.${i}`] = filters[i];
      }
      if ((i == "from" && i["from"] != "") || (i == "to" && i["to"] != "")) {
        filter[i] = filters[i];
      }
    }
    return filter;
  };

  const handleFilter = () => {
    setPage(1);
    dispatch(getAllSalesOrders(searchTerm, sort, sortBy, "", filterFun()));
  };
  const handleClear = () => {
    TabChange();
    dispatch(getAllSalesOrders(searchTerm, sort, sortBy, page, {}));
  };
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  //debouncing for search
  const handleSearch = (value) => {
    setPage(1);
    dispatch(getAllSalesOrders(value, sort, sortBy, "", filterFun()));
  };

  const debouncedHandleSearch = debounce(handleSearch, 1000);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Div sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Div>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  useEffect(() => {
    if (searchTerm !== "") {
      debouncedHandleSearch(searchTerm);
    }
    return () => {
      debouncedHandleSearch.cancel();
    };
  }, [searchTerm]);

  useEffect(() => {
    dispatch(getAllSalesOrders(searchTerm, sort, sortBy, page, filterFun()));
  }, [sort, page]);

  useEffect(() => {
    (async () => {
      try {
        let response = await Axios.get(AllApis.salesOrder.orderNoFromSales);
        setDropdownList((prev) => ({
          ...prev,
          orderNoList: response.data.data,
        }));
      } catch (error) {
        console.error("Error:", error);
      }
    })();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <Div sx={{ mt: -4 }}>
        <Heading Name={"Sales Orders"} />
        <Div className="Filters" sx={{ width: "100%", mt: 4 }}>
          <Typography variant="h1" sx={{ mb: 3 }}>
            Filters
          </Typography>
          <Box
            sx={{ display: "flex", rowGap: 4, columnGap: 4, flexWrap: "wrap" }}
          >
            <Div sx={{ width: "23%" }}>
              <Autocomplete
                key={emptyVal ? "refresh1" : "refresh2"}
                sx={{ width: "100%", textTransform: "capitalize" }}
                size="small"
                id="company-autocomplete"
                options={dropdownList?.stateList || []}
                getOptionLabel={(option) => option?.name || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.name === value?.name
                }
                onChange={(e, newValue) => {
                  setFilters({
                    ...filters,
                    "customer_details.bill_to.address.state":
                      newValue != null ? newValue?.name?.toLowerCase() : "",
                  });
                  const cityNames = City.getCitiesOfState(
                    "IN",
                    newValue.isoCode
                  );
                  setDropdownList({ ...dropdownList, cityList: cityNames });
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option?.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="State" />
                )}
              />
            </Div>
            <Div sx={{ width: "23%" }}>
              <Autocomplete
                key={emptyVal ? "refresh1" : "refresh2"}
                sx={{ width: "100%", textTransform: "capitalize" }}
                size="small"
                id="company-autocomplete"
                options={dropdownList?.cityList || []}
                getOptionLabel={(option) => option?.name || ""}
                // isOptionEqualToValue={
                //   (option, value) => console.log(option?.name, value)
                //   option?.name === value?.name
                // }
                onChange={(e, newValue) => {
                  setFilters({
                    ...filters,
                    "customer_details.bill_to.address.city":
                      newValue != null ? newValue?.name?.toLowerCase() : "",
                  });
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option?.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="City" />
                )}
              />
            </Div>
            <Div sx={{ width: "23%" }}>
              <Autocomplete
                key={emptyVal ? "refresh1" : "refresh2"}
                sx={{ width: "100%", textTransform: "capitalize" }}
                size="small"
                id="company-autocomplete"
                options={taluka || []}
                getOptionLabel={(option) => option?.name || ""}
                // isOptionEqualToValue={
                //   (option, value) => console.log(option?.name, value)
                //   option?.name === value?.name
                // }
                onChange={(e, newValue) => {
                  setFilters({
                    ...filters,
                    "customer_details.bill_to.address.taluka":
                      newValue != null ? newValue?.name?.toLowerCase() : "",
                  });
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option?.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Taluka" />
                )}
              />
            </Div>
            <Div sx={{ width: "23%" }}>
              <Autocomplete
                key={emptyVal ? "refresh1" : "refresh2"}
                sx={{ width: "100%", textTransform: "capitalize" }}
                size="small"
                id="company-autocomplete"
                options={district || []}
                getOptionLabel={(option) => option?.name || ""}
                // isOptionEqualToValue={
                //   (option, value) => console.log(option?.name, value)
                //   option?.name === value?.name
                // }
                onChange={(e, newValue) => {
                  setFilters({
                    ...filters,
                    "customer_details.bill_to.address.district":
                      newValue != null ? newValue?.name?.toLowerCase() : "",
                  });
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option?.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="District" />
                )}
              />
            </Div>

            <Div sx={{ width: "23%" }}>
              <Autocomplete
                key={emptyVal ? "refresh1" : "refresh2"}
                sx={{ width: "100%", textTransform: "capitalize" }}
                size="small"
                id="company-autocomplete"
                options={dropdownList?.orderNoList || []}
                getOptionLabel={(option) => option?._id || ""}
                // isOptionEqualToValue={
                //   (option, value) => console.log(option?.name, value)
                //   option?.name === value?.name
                // }
                onChange={(e, newValue) => {
                  setFilters({
                    ...filters,
                    order_no: newValue != null ? newValue?._id : "",
                  });
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option?._id}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Order No" />
                )}
              />
            </Div>
            <Div sx={{ width: "23%" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  key={emptyVal ? "refresh1" : "refresh2"}
                  id="from"
                  format="DD-MM-YYYY"
                  name="from"
                  label="From Sales Order Date"
                  sx={datepickerStyling}
                  defaultValue={
                    filters.from !== "" ? dayjs(filters.from) : null
                  }
                  onChange={(newValue) => {
                    setFilters({
                      ...filters,
                      from: newValue.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                    });
                  }}
                  slotProps={{ textField: { size: "small" } }}
                />
              </LocalizationProvider>
              {filters?.to && !filters?.from && (
                <Typography
                  sx={{
                    color: "#E73145",
                    fontSize: "0.75rem",
                    ml: 1,
                    mt: 0.5,
                  }}
                >
                  Select From Sales Order Date{" "}
                </Typography>
              )}
            </Div>
            <Div sx={{ width: "23%" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  key={emptyVal ? "refresh1" : "refresh2"}
                  id="to"
                  format="DD-MM-YYYY"
                  name="to"
                  label="To Sales Order Date"
                  sx={datepickerStyling}
                  defaultValue={filters.to !== "" ? dayjs(filters.to) : null}
                  onChange={(newValue) => {
                    setFilters({
                      ...filters,
                      to: newValue.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                    });
                  }}
                  slotProps={{ textField: { size: "small" } }}
                />
              </LocalizationProvider>
              {!filters?.to && filters?.from && (
                <Typography
                  sx={{
                    color: "#E73145",
                    fontSize: "0.75rem",
                    ml: 1,
                    mt: 0.5,
                  }}
                >
                  Select To Sales Order Date{" "}
                </Typography>
              )}
            </Div>
          </Box>
          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              sx={{ marginRight: 1 }}
              onClick={handleFilter}
            >
              Apply
            </Button>
            {/* <Button variant="outlined" onClick={handleClears}> */}
            <Button variant="outlined" onClick={handleClear}>
              Clear
            </Button>
          </Box>
        </Div>
      </Div>

      <Div>
        <Div
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TextField
            id="search"
            type="search"
            label="Search"
            value={searchTerm}
            size="small"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              if (e.target.value == "") {
                setPage(1);
                setSort("desc");
                setSortBy("created_at");
                dispatch(
                  getAllSalesOrders("", "desc", "created_at", 1, filterFun())
                );
              }
            }}
            sx={{ width: 300, mb: 5, mt: 4 }}
            InputProps={{
              endAdornment: (
                <Div sx={{ cursor: "pointer" }}>
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                </Div>
              ),
            }}
          />
          <Div>
            {/* <Button
            variant="contained"
            sx={{
              mr: 2,
              p: 1,
              pl: 4,
              pr: 4,
            }}
            onClick={() => setLogModalOpen(true)}
          >
            Logs
          </Button> */}
          </Div>
        </Div>

        <SalesTable
          filter={filterFun}
          page={page}
          setPage={setPage}
          search={searchTerm}
          sort={sort}
          setSort={setSort}
          sortBy={sortBy}
          setSortBy={setSortBy}
        />
      </Div>
    </>
  );
}
